// src/axios/axios_public.js
import axios from 'axios';
import * as sabitler from '../sabitler.js';
import Cookies from 'js-cookie';

//console.log('axios/axios_public.js')

const instance = axios.create({
    baseURL: sabitler.apiBase2URL,
    headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': Cookies.get('csrftoken')
    }
});


export default instance;